import { Component, OnInit, Input, HostBinding, Inject, Renderer2, ElementRef } from '@angular/core';
import { encapsulation } from '../../../encapsulation';
import { UBXFieldBlockComponent } from '../../block/field-block.component';

@Component({
    selector: 'ubx-option',
    templateUrl: './option.component.html',
    host: { class: 'ubx-option flx f-ai:c' },
    encapsulation
})
export class UBXOptionComponent implements OnInit {
    @Input() @HostBinding('class.isSelected') selected: boolean;

    constructor(
        private renderer: Renderer2,
        public el: ElementRef,
        @Inject(UBXFieldBlockComponent) private block: UBXFieldBlockComponent,
    ) { }

    ngOnInit() {
        this.appendClass(this.block.accent);
    }

    private appendClass(name: string) {
        this.renderer.addClass(this.el.nativeElement, name);
    }
}
